@for (shift of shifts(); track $index) {
  <div class="shift" [style.flex-grow]="shift.durationInMinutes" [class.empty-space]="!shift.name" [class.alternate]="shift.alternate" [matTooltip]="shift.name"></div>
}
